import React, { Component } from "react";
import instanceHuay from "./axios-instanceHuay";
import Swal from 'sweetalert2';
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numberSets: [{ id: 1, option: "", number: "" }],
            nextId: 2,
            playerx: this.props.props.username || null,
            room: "",
            poyname: "",
            Dynamicsetting: [],
        };
    }

    savePoylist = async () => {
        const token = localStorage.getItem("auth_token");
        const decoded = token ? jwt_decode(token) : null;

        const Username = decoded?.message?.playerid;
        const { numberSets, poyname, Dynamicsetting } = this.state;

        // Validate poyname
        if (!poyname || poyname.trim() === "") {
            Swal.fire({
                icon: "warning",
                title: "กรุณาใส่ชื่อชุด",
                text: "กรุณาระบุชื่อชุดก่อนบันทึกข้อมูล",
            });
            return;
        }

        // Validate numberSets
        if (!numberSets || numberSets.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "ไม่มีเลขชุด",
                text: "กรุณาเพิ่มเลขชุดก่อนบันทึก",
            });
            return;
        }


        // Validate digits and retrieve type
        for (const set of numberSets) {
            const setting = Dynamicsetting.find((dynamic) => dynamic.keyid === set.option);
            if (!setting) {
                Swal.fire({
                    icon: "error",
                    title: "ข้อผิดพลาด",
                    text: `ไม่พบการตั้งค่าของเลข ${set.number}`,
                });
                return;
            }

            if (set.number.length !== setting.digit) {
                Swal.fire({
                    icon: "error",
                    title: "เลขไม่ถูกต้อง",
                    text: `เลข ${set.number} ต้องมีจำนวนหลักเท่ากับ ${setting.digit}`,
                });
                return;
            }

            // Attach `type` to each number set (e.g., "3ตัวบน", "2ตัวล่าง")
            set.type = setting.key;
        }

        console.log(Username    , poyname, numberSets);

        // Prepare data for the API request
        const payload = {
            poyname, // Include the poyname
            numbers: numberSets.map((set) => ({
                number: set.number,
                keyid: set.option, // Use option as keyid
                type: set.type, // Include the type (retrieved from Dynamicsetting)
            })),
            playerid: Username, // ✅ แก้ตรงนี้
            system: Systems || "defaultSystem",
        };

        const apiUrl = "/api/v1/savepoylist";
        const headers = {
            "Content-Type": "application/json",
        };

        try {
            const response = await instanceHuay.post(apiUrl, payload, { headers });

            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกสำเร็จ",
                    text: "ข้อมูลเลขชุดถูกบันทึกเรียบร้อยแล้ว!",
                });
                this.setState({
                    numberSets: [{ id: 1, option: "", number: "" }],
                    nextId: 2,
                    poyname: "", // Reset poyname
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: response.data.message || "ไม่สามารถบันทึกข้อมูลได้",
                });
                console.error("Error saving Poylist:", response.data.message);
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "ข้อผิดพลาดระบบ",
                text: error.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
            });
            console.error("Error saving Poylist:", error.message);
        }
    };
    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };
    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    async callgetthemesv() {
        // 1) ถ้ามี cache ที่ยัง valid ให้ใช้ทันที (fast)
        const cacheKey = "theme_v1";
        const ttl = 500 * 60 * 60 * 1000;
        const cached = this.getCache ? this.getCache(cacheKey, ttl) : null;
        if (cached) {
            // Apply cached theme right away
            document.body.setAttribute("data-theme", cached);
            this.setState({ ThmeseLottoV: cached });
            return;
        }
    }
    async componentDidMount() {
        // Restore state from local storage if available
        const typename = localStorage.getItem("typename");
        const stateKeys = JSON.parse(localStorage.getItem("stateKeys")) || {};
        if (typename) {
            this.setState({ typename });
        }
        this.setState({ ...stateKeys });
    }

    handleInputChange = (id, field, value) => {
        const updatedNumberSets = this.state.numberSets.map((set) =>
            set.id === id ? { ...set, [field]: value } : set
        );
        this.setState({ numberSets: updatedNumberSets });
    };

    handleInputChangeName = (e) => {
        const { name, value } = e.target; // ดึง name และ value จากอินพุตที่เปลี่ยนแปลง
        this.setState({ [name]: value }); // อัปเดตสถานะโดยใช้ชื่อฟิลด์
    };
    addNumberSet = () => {
        const { numberSets, nextId } = this.state;
        this.setState({
            numberSets: [...numberSets, { id: nextId, option: "", number: "" }],
            nextId: nextId + 1,
        });
    };

    deleteNumberSet = (id) => {
        const filteredNumberSets = this.state.numberSets.filter((set) => set.id !== id);
        this.setState({ numberSets: filteredNumberSets });
    };

    render() {
        const { Dynamicsetting } = this.state;
        return (
            <div id="section-content" className="container container-fluid">
                <form
                    className="form-login form-horizontal"
                    id="add_numbersets"
                    role="form"
                    method="post"
                    onSubmit={(e) => {
                        e.preventDefault();
                        this.savePoylist();
                    }}
                >
                    <div className="bar-back">
                        <a href={`/numbersets/${window.location.search}`}>
                            <i className="fas fa-chevron-left"></i> จัดการเลขชุด
                        </a>
                    </div>

                    <div
                        className="p-2 w-100 bg-light main-content align-self-stretch"
                        style={{ minHeight: "calc(-226px + 100vh)" }}
                    >
                        <div className="text-secondary shadow-sm rounded p-2 px-2 xtarget col-lotto d-flex flex-row justify-content-between mb-1 pb-0">
                            <div className="lotto-title">
                                <h4>
                                    <i className="fas fa-plus"></i> สร้างเลขชุด
                                </h4>
                            </div>
                        </div>

                        <div className="text-secondary shadow-sm rounded pt-2 px-2 pb-0 xtarget col-lotto">
                            <div className="row px-2 align-items-center">
                                <div className="col-12 col-sm-12 col-md-2 pr-1">
                                    <label>
                                        <i className="fas fa-list-ol"></i> ชื่อชุด
                                    </label>
                                </div>
                                <div className="col-12 col-sm-12 col-md-8 px-1">
                                    <input
                                        name="poyname"
                                        type="text"
                                        value={this.state.poyname} // เชื่อมโยงกับ state
                                        onChange={this.handleInputChangeName} // ใช้ฟังก์ชันเปลี่ยนแปลงค่า
                                        placeholder="ระบุชื่อเรียกเลขชุด"
                                        className="form-control form-control-sm"
                                        required
                                    />
                                </div>

                                <div className="col-12">
                                    <label>
                                        <i className="fas fa-plus-square"></i> สร้างชุดตัวเลข
                                    </label>
                                </div>

                                <div className="col-12">
                                    <ol className="pl-2" id="add_numbersets_list">
                                        {this.state.numberSets.map((set) => (
                                            <li className="mb-2" key={set.id}>
                                                <div className="row">
                                                    <div className="col-5 col-sm-5 col-md-2 pr-1">
                                                        <select
                                                            name="option[]"
                                                            className="form-control dropdown-numberset"
                                                            value={set.option || ""}
                                                            onChange={(e) =>
                                                                this.handleInputChange(set.id, "option", e.target.value)
                                                            }
                                                        >
                                                            <option value="" disabled>
                                                                เลือกประเภท
                                                            </option>
                                                            {Dynamicsetting.filter((option) => option.enabled === 1).map((dynamic) => (
                                                                <option key={dynamic.keyid} value={dynamic.keyid}>
                                                                    {dynamic.key}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-5 col-sm-5 col-md-8 px-1">
                                                        <input
                                                            type="tel"
                                                            className="form-control form-control-sm"
                                                            name="number[]"
                                                            value={set.number}
                                                            onChange={(e) =>
                                                                this.handleInputChange(set.id, "number", e.target.value)
                                                            }
                                                            minLength={Dynamicsetting.find((dynamic) => dynamic.keyid === set.option)?.digit || 1}
                                                            maxLength={Dynamicsetting.find((dynamic) => dynamic.keyid === set.option)?.digit || 1}
                                                            required
                                                            onInput={(e) =>
                                                                (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-2 col-sm-2 col-md-2 pl-1">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => this.deleteNumberSet(set.id)}
                                                        >
                                                            <i className="fas fa-trash-alt"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ol>
                                </div>

                                <div className="col-12 table-primary py-2 rounded-bottom">
                                    <button
                                        className="btn btn-outline-primary btn-block"
                                        type="button"
                                        onClick={this.addNumberSet}
                                    >
                                        <i className="fas fa-plus-circle"></i> เพิ่มชุดตัวเลข
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-2 rounded shadow-sm w-100 mb-5">
                            <div className="row">
                                <div className="col pr-1">
                                    <button className="btn btn-secondary btn-block" type="reset">
                                        ยกเลิก
                                    </button>
                                </div>
                                <div className="col pl-1">
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.savePoylist();
                                        }}
                                        className="btn btn-success btn-block"
                                        type="submit"
                                    >
                                        <i className="fas fa-save"></i> บันทึก
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default App;
